// extracted by mini-css-extract-plugin
module.exports = {"main_sec":"style_main_sec__XLKF8","right":"style_right__1_k12","inner":"style_inner__Lo2nT","main-img":"style_main-img__2TJoM","left":"style_left__2HOCQ"};